import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEn from './translation.en.json';
import translationKo from './translation.ko.json';

const resources = {
  en: {
    translation: translationEn
  },
  ko: {
    translation: translationKo
  }
}

function getNavigatorLanguages() {
  if (typeof navigator === 'undefined') return [];

  if (Array.isArray(navigator.languages) && navigator.languages.length > 0) {
    return navigator.languages.filter(Boolean);
  }

  if (navigator.language) return [navigator.language];

  return [];
}

function detectDeviceI18nLanguage() {
  const languages = getNavigatorLanguages().map((language) => language.toLowerCase());
  const isKoreanDevice = languages.some((language) => language === 'ko' || language.startsWith('ko-'));

  return isKoreanDevice ? 'ko' : 'en';
}

export function getAppLanguageFromI18nLanguage(language) {
  return language === 'ko' ? 'Korea' : 'English';
}

export function getI18nLanguageFromAppLanguage(language) {
  return language === 'Korea' ? 'ko' : 'en';
}

export function getDefaultAppLanguage() {
  return getAppLanguageFromI18nLanguage(detectDeviceI18nLanguage());
}

function isValidAppLanguage(language) {
  return language === 'Korea' || language === 'English';
}

function isReactNativeWebViewEnvironment() {
  if (typeof window === 'undefined') return false;

  return window.ReactNativeWebView !== undefined;
}

function getStoredAppLanguage() {
  if (typeof window === 'undefined') return null;

  const language = window.localStorage.getItem('Language');

  return isValidAppLanguage(language) ? language : null;
}

function getConfirmedSessionAppLanguage() {
  if (typeof window === 'undefined') return null;

  const language = window.sessionStorage.getItem('ConfirmedAppLanguage');

  return isValidAppLanguage(language) ? language : null;
}

export function hasConfirmedAppLanguage() {
  return getConfirmedSessionAppLanguage() !== null;
}

export function confirmAppLanguage(language) {
  if (typeof window === 'undefined' || !isValidAppLanguage(language)) return;

  window.localStorage.setItem('Language', language);
  window.sessionStorage.setItem('ConfirmedAppLanguage', language);
}

export function getStoredOrDeviceAppLanguage() {
  if (typeof window === 'undefined') return getDefaultAppLanguage();

  const confirmedLanguage = getConfirmedSessionAppLanguage();
  if (confirmedLanguage !== null) {
    return confirmedLanguage;
  }

  const defaultLanguage = getDefaultAppLanguage();

  if (isReactNativeWebViewEnvironment()) {
    return defaultLanguage;
  }

  const savedLanguage = getStoredAppLanguage();
  if (savedLanguage !== null) {
    return savedLanguage;
  }

  window.localStorage.setItem('Language', defaultLanguage);
  return defaultLanguage;
}

const initialAppLanguage = getStoredOrDeviceAppLanguage();
const initialI18nLanguage = getI18nLanguageFromAppLanguage(initialAppLanguage);

i18n
.use(initReactI18next)
.init({
  resources: resources,
  lng: initialI18nLanguage,
  fallbackLng: "ko",
  debug: true,
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
})

export default i18n;
